import { Component, OnInit } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { pairwise } from 'rxjs/operators';

@Component({
  selector: 'webapp-compat-navigation',
  template: `
    <app-navigation [transparent]="transparent"></app-navigation>
  `,
})
export class CompatNavigationComponent implements OnInit {
  transparent: boolean;

  constructor(private auth: Auth) {}

  ngOnInit() {
    // Note: this is a hack for allowing us to set transparent navigation
    // if the PHP template variable transparent_header is set to true.
    this.transparent = (<any>window).webappCompat.navigation.transparent;

    // HACK to force reload the current page when SwitchAccount is used. This
    // is needed of legacy pages as parts of the UI won't react to the
    // AuthState update.
    this.auth.authState.pipe(pairwise()).subscribe(([previousAuth, auth]) => {
      if (previousAuth && auth && previousAuth.userId !== auth.userId) {
        window.location.reload();
      }
    });
  }
}
